export function roundTo(value: number, roundTo: number = 5): number {
    /**
     * Rounds a given value to the nearest interval of 5.
     *
     * @param {number} value - The value to be rounded.
     * @return {number} The rounded value.
     */
    return Math.round(value / roundTo) * roundTo;
  }